module.exports = __webpack_public_path__ + "img/html-evolution-5.64652fbb.webp";